/* eslint-disable @next/next/no-img-element */
//components
import { Container } from '@/components/Grid';

//miranda button
import { MirandaHollowButton } from '@/components/Button/BaseButton';

//styles
import {
  SideCTAReverseWrapper,
  ImageSpacer,
  ContentHolder,
  FooterContent,
  Title,
  Description,
} from './SideCTAReverse.styles';

export function SideCTAReverse({ content }) {
  return (
    <>
      <SideCTAReverseWrapper>
        <Container>
          <ContentHolder>
            <Title as="h2">
              Discover if You’re Ready for a Managed Transportation Partner
            </Title>
            <Description as="p">
              This tool helps you assess critical areas: scalability, talent
              gaps, planning, analytics, and common misconceptions. Discover if
              your logistics team could benefit from added expertise, advanced
              tools, or just an extra set of hands.
            </Description>
            <FooterContent>
              <MirandaHollowButton
                as="a"
                target="_blank"
                rel="noreferrer noopener"
                href="https://lp.loadsmart.com/en/managed-transportation-checklist"
              >
                Download the Checklist
              </MirandaHollowButton>
            </FooterContent>
          </ContentHolder>
          <ImageSpacer role="presentation">
            <img
              src="/images/managed-transportation/mt-side-rev-xxlg.webp"
              alt=""
            />
          </ImageSpacer>
        </Container>
      </SideCTAReverseWrapper>
    </>
  );
}
